import Success from '../assets/tick.png'

export default function AlertModal({ handleFormReset }) {
	return (
		<div className='modalOverlay'>
			<div className='modalCover'>
				<div className='p-5 flex-col flex items-center'>
					<img src={Success} alt='icon' className='object-contain w-20 mb-3' />
					<p>Success!!</p>
					<p className='text-xs text-gray-400'>
						the card has been successfully added.
					</p>
					<button onClick={handleFormReset} className='submitBtn'>
						Close
					</button>
				</div>
			</div>
		</div>
	)
}
